import { useState } from 'react';
import { Video } from 'lucide-react';

interface VideoCallScheduleProps {
  customizationId: number;
  onScheduleVideoCall: (customizationId: number) => Promise<void>;
  onBookNowClick?: () => void;
}

export function VideoCallSchedule({
  customizationId,
  onScheduleVideoCall,
  onBookNowClick,
}: VideoCallScheduleProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleBookNow = async () => {
    if (isLoading) return;
    setErrorMessage(null);
    setIsLoading(true);
    try {
      await onScheduleVideoCall(customizationId);
      onBookNowClick?.();
    } catch {
      setErrorMessage('Unable to schedule video call. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className=" px-4 py-4 md:px-0 border-t border-[#eee]">
      <div className="flex items-center gap-3">
        <Video className="h-5 w-5 shrink-0 text-[#5BA10F]" strokeWidth={1.75} aria-hidden />
        <span className="text-sm text-gray-900">Schedule video call</span>
        <button
          type="button"
          onClick={handleBookNow}
          disabled={isLoading}
          className="text-sm text-[var(--link-blue)] hover:underline disabled:opacity-50"
        >
          {isLoading ? 'Booking…' : 'Book Now'}
        </button>
      </div>
      {errorMessage && (
        <p className="mt-2 text-xs text-red-500">{errorMessage}</p>
      )}
    </div>
  );
}
